import { publicGet } from '../publicClient';

export interface WsTokenResponse {
    token: string;
}

export function getWsToken(): Promise<WsTokenResponse> {
    return publicGet<WsTokenResponse>(
        `https://${
            process.env.REACT_APP_WEBSOCKET_DOMAIN ?? location.hostname
        }/api/v2/login/observer`
    );
}
